<template>
  <div class="fill-height home-font-style">
    <v-app-bar app
               class="app-bar-style"
               elevation="0"
               fixed
               color="white">
      <v-row>
        <v-col class="d-flex align-center nude_btn">
          <v-img
              height="24"
              :src="require('@/assets/images/OnuLogo.png')"
              max-width="100"
              contain
          />
        </v-col>
        <v-col
            v-if="$vuetify.breakpoint.lgAndUp"
            class="d-flex justify-end align-center">
          <v-btn
              class="btn-text"
              rounded
              elevation="0"
              @click="toSignInPage"
              color="primary"
              target="_blank">
            무료로 시작하기
          </v-btn>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-main class="main-style">
      <v-container>
        <v-row class="row-style mt-10">
          <v-col :cols="$vuetify.breakpoint.lgAndUp ? 8 : 12">
            <div class="mx-auto">
              <div class="mb-3 title-style-1">
                1분<span class="title-style-1-light">이면 우리매장</span> 메뉴판 완성 !
              </div>
              <div class="mb-6 title-style-2">
                QR 모바일 메뉴판, 오뉴
              </div>
              <div class="mb-6 description-style">
                오뉴의 온라인 메뉴판은 사장님의 매출향상과 소비자의
                구매심리학에 기반한 메뉴 디자인에 집중한 메뉴판입니다.
                사장님들은 오뉴의 관리자 사이트를 통해 메뉴판을 쉽고
                빠르게 실시간으로 변경할 수 있습니다.
              </div>
              <div>
                <v-btn
                    class="btn-text mr-4"
                    rounded
                    elevation="0"
                    @click="toSignInPage"
                    color="primary"
                    target="_blank">
                  지금 시작하기
                </v-btn>
                <v-btn
                    class="btn-text"
                    rounded
                    outlined
                    href="https://drive.google.com/file/d/1AI8Bqxa0eETDFDRGefOscLcVhJr5bfxK/view"
                    color="primary"
                    target="_blank">
                  서비스 소개서
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.smAndUp"
                 :cols="$vuetify.breakpoint.lgAndUp ? 4 : 12"
                 class="d-flex justify-center"
          >
            <v-img
                :max-width="$vuetify.breakpoint.lgAndUp ? '100%' : '50%'"
                :src="require('@/assets/images/HomeMainImage.png')"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

  </div>
</template>

<script>

import routerName from "@/constants/routerName";

export default {
  name: "Home",
  methods: {
    toSignInPage() {
      this.$router.push({name: routerName.SIGN_IN})
    },
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'S-CoreDream-8Heavy';
  src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-8Heavy.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'S-CoreDream-6Bold';
  src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-6Bold.woff') format('woff');
  font-weight: normal;
  font-weight: normal;
}

@font-face {
  font-family: 'S-CoreDream-4Regular';
  src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-4Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'S-CoreDream-3Light';
  src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/S-CoreDream-3Light.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

.home-font-style {
  font-family: 'S-CoreDream-6Bold', Roboto, sans-serif;
}

.app-bar-style {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12) !important;
}

.btn-text {
  font-weight: 600;
  font-size: 14px;
}

.main-style {
  display: flex;
  align-items: center;
  height: 100%;
}

.row-style {
  display: flex;
  align-items: center;
}

.title-style-1 {
  font-size: 32px;
  line-height: 38px;
  letter-spacing: -0.05em;
  text-transform: capitalize;
  color: #222222;
}

.title-style-1-light {
  font-family: 'S-CoreDream-4Regular', Roboto, sans-serif;
}

.title-style-2 {
  font-family: 'S-CoreDream-8Heavy', Roboto, sans-serif;
  font-weight: 800;
  font-size: 56px;
  line-height: 67px;
  letter-spacing: -0.05em;
  text-transform: capitalize;
  color: #222222;
}

.description-style {
  max-width: 374px;
  font-family: 'S-CoreDream-3Light', Roboto, sans-serif;
  font-weight: 300;
  font-size: 14px;
  line-height: 28px;
  letter-spacing: -0.03em;
  color: #484848;
}

</style>